/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component } from "@angular/core";

@Component({
  selector: "app-load-spinner",
  templateUrl: "./load-spinner.component.html",
  styleUrls: ["./load-spinner.component.scss"]
})
export class LoadSpinnerComponent {}
